<template>
  <b-container fluid class="landing">
    <b-row>
      <b-col class="col-10 mx-auto py-5 my-5">
        <div class="privacy-policy-container">
          <!-- Language Switcher -->
          <div class="language-switcher">
            <b-button size="sm" @click="setLang('es')" :variant="currentLang === 'es' ? 'primary' : 'outline-secondary'">Español</b-button>
            <b-button size="sm" @click="setLang('en')" :variant="currentLang === 'en' ? 'primary' : 'outline-secondary'">English</b-button>
          </div>

          <h1>{{ content[currentLang].title }}</h1>
          <p>{{ content[currentLang].lastUpdated }}: {{ new Date().toLocaleDateString(content[currentLang].locale) }}</p>

          <p>{{ content[currentLang].welcome }}</p>

          <h2>{{ content[currentLang].infoCollectedTitle }}</h2>
          <p>{{ content[currentLang].infoCollectedIntro }}</p>
          <ul>
            <li v-for="item in content[currentLang].infoCollectedItems" :key="item">{{ item }}</li>
          </ul>

          <h2>{{ content[currentLang].howWeUseInfoTitle }}</h2>
          <p>{{ content[currentLang].howWeUseInfoIntro }}</p>
          <ul>
             <li v-for="item in content[currentLang].howWeUseInfoItems" :key="item">{{ item }}</li>
          </ul>

          <h2>{{ content[currentLang].howWeShareInfoTitle }}</h2>
          <p>{{ content[currentLang].howWeShareInfoText }}</p>

          <h2>{{ content[currentLang].securityTitle }}</h2>
          <p>{{ content[currentLang].securityText }}</p>

          <h2>{{ content[currentLang].childrenPrivacyTitle }}</h2>
          <p>{{ content[currentLang].childrenPrivacyText }}</p>

          <h2>{{ content[currentLang].yourRightsTitle }}</h2>
          <p>{{ content[currentLang].yourRightsText }}</p>

          <h2>{{ content[currentLang].changesTitle }}</h2>
          <p>{{ content[currentLang].changesText1 }}</p>
          <p>{{ content[currentLang].changesText2 }}</p>

          <h2>{{ content[currentLang].contactTitle }}</h2>
          <p>{{ content[currentLang].contactIntro }}</p>
          <ul>
            <li>{{ content[currentLang].contactEmail }}: <a href="mailto:atencionalcliente@puntosgox.com">atencionalcliente@puntosgox.com</a></li>
            <li>{{ content[currentLang].contactWebsite }}: <a href="https://puntosgox.com/nosotros">https://puntosgox.com</a></li>
          </ul>
        </div>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
export default {
  name: 'PrivacyPolicy',
  data() {
    return {
      currentLang: 'es', // Default language
      content: {
        es: {
          locale: 'es-ES',
          title: 'Política de Privacidad',
          lastUpdated: 'Última actualización',
          welcome: 'Bienvenido/a a GoX. Esta política de privacidad explica cómo recopilamos, usamos, divulgamos y protegemos tu información cuando utilizas nuestra aplicación móvil.',
          infoCollectedTitle: 'Información que Recopilamos',
          infoCollectedIntro: 'Cuando utilizas GoX, recopilamos información sobre tu dispositivo, como:',
          infoCollectedItems: [
            'Tipo de dispositivo',
            'Sistema operativo',
            'ID de dispositivo',
            'Datos de uso',
            'Información de ubicación (si está permitida)',
            'Información de la aplicación',
            'Información de la cuenta (si estás registrado)',
            'Información de transacciones (si realizas compras)',
            'Información de publicidad (si interactúas con anuncios)',
            'Información de búsqueda (si buscas productos o servicios)',
            'Información de cookies y tecnologías similares (si estás utilizando un navegador web)'
          ],
          howWeUseInfoTitle: 'Cómo Usamos tu Información',
          howWeUseInfoIntro: 'Utilizamos la información recopilada para:',
          howWeUseInfoItems: [
             'Proporcionar y mantener la aplicación',
             'Mejorar la experiencia del usuario',
             'Comunicarnos contigo',
             'Cumplir con requisitos legales'
          ],
          howWeShareInfoTitle: 'Cómo Compartimos tu Información',
          howWeShareInfoText: 'No compartimos tu información con terceros. Sin embargo, podemos compartir información anónima y agregada con terceros para fines de análisis y mejoras en la aplicación.',
          securityTitle: 'Seguridad de tu Información',
          securityText: 'Implementamos medidas de seguridad para proteger tus datos. Sin embargo, ninguna transmisión de datos a través de Internet es 100% segura.',
          childrenPrivacyTitle: 'Privacidad de los Niños',
          childrenPrivacyText: 'Nuestra aplicación no está dirigida a niños menores de 13 años. No recopilamos intencionadamente información personal identificable de niños menores de 13 años. Si descubrimos que un niño menor de 13 años nos ha proporcionado información personal, la eliminamos inmediatamente de nuestros servidores. Si eres padre o tutor y sabes que tu hijo nos ha proporcionado información personal, por favor, contáctanos para que podamos tomar las acciones necesarias.',
          yourRightsTitle: 'Tus Derechos',
          yourRightsText: 'Tienes derecho a acceder, corregir, eliminar o limitar el uso de tus datos. Para ejercer estos derechos, por favor, contáctanos a través de los canales proporcionados en la sección de contacto.',
          changesTitle: 'Cambios a esta Política de Privacidad',
          changesText1: 'Podemos actualizar nuestra Política de Privacidad de vez en cuando. Te notificaremos cualquier cambio publicando la nueva Política de Privacidad en esta página.',
          changesText2: 'Se te aconseja revisar esta Política de Privacidad periódicamente para cualquier cambio. Los cambios a esta Política de Privacidad son efectivos cuando se publican en esta página.',
          contactTitle: 'Contáctanos',
          contactIntro: 'Si tienes alguna pregunta sobre esta Política de Privacidad, puedes contactarnos:',
          contactEmail: 'Por email',
          contactWebsite: 'Visitando esta página en nuestro sitio web'
        },
        en: {
          locale: 'en-US',
          title: 'Privacy Policy',
          lastUpdated: 'Last updated',
          welcome: 'Welcome to GoX. This privacy policy explains how we collect, use, disclose, and protect your information when you use our mobile application.',
          infoCollectedTitle: 'Information We Collect',
          infoCollectedIntro: 'When you use GoX, we collect information about your device, such as:',
          infoCollectedItems: [
            'Device type',
            'Operating system',
            'Device ID',
            'Usage data',
            'Location information (if permitted)',
            'Application information',
            'Account information (if registered)',
            'Transaction information (if you make purchases)',
            'Advertising information (if you interact with ads)',
            'Search information (if you search for products or services)',
            'Cookie information and similar technologies (if using a web browser)'
          ],
          howWeUseInfoTitle: 'How We Use Your Information',
          howWeUseInfoIntro: 'We use the collected information to:',
           howWeUseInfoItems: [
             'Provide and maintain the application',
             'Improve user experience',
             'Communicate with you',
             'Comply with legal requirements'
          ],
          howWeShareInfoTitle: 'How We Share Your Information',
          howWeShareInfoText: 'We do not share your information with third parties. However, we may share anonymous and aggregated information with third parties for analysis and application improvement purposes.',
          securityTitle: 'Security of Your Information',
          securityText: 'We implement security measures to protect your data. However, no data transmission over the Internet is 100% secure.',
          childrenPrivacyTitle: "Children's Privacy",
          childrenPrivacyText: "Our application is not directed to children under 13 years of age. We do not knowingly collect personally identifiable information from children under 13. If we discover that a child under 13 has provided us with personal information, we immediately delete it from our servers. If you are a parent or guardian and you are aware that your child has provided us with personal information, please contact us so that we can take necessary actions.",
          yourRightsTitle: 'Your Rights',
          yourRightsText: 'You have the right to access, correct, delete, or limit the use of your data. To exercise these rights, please contact us through the channels provided in the contact section.',
          changesTitle: 'Changes to This Privacy Policy',
          changesText1: 'We may update our Privacy Policy from time to time. We will notify you of any changes by posting the new Privacy Policy on this page.',
          changesText2: 'You are advised to review this Privacy Policy periodically for any changes. Changes to this Privacy Policy are effective when they are posted on this page.',
          contactTitle: 'Contact Us',
          contactIntro: 'If you have any questions about this Privacy Policy, you can contact us:',
          contactEmail: 'By email',
          contactWebsite: 'By visiting this page on our website'
        }
      }
    };
  },
  methods: {
    setLang(lang) {
      this.currentLang = lang;
    }
  }
};
</script>

<style scoped>
.privacy-policy-container {
  padding: 20px;
  max-width: 800px;
  margin: 0 auto;
  font-family: sans-serif;
  position: relative; /* Added for positioning the switcher */
}

.language-switcher {
  position: absolute;
  top: 20px; /* Adjust as needed */
  right: 20px; /* Adjust as needed */
  display: flex;
  gap: 5px; /* Space between buttons */
}

h1 {
  text-align: center;
  margin-bottom: 30px;
}

h2 {
  margin-top: 20px;
  margin-bottom: 10px;
}

p,
ul {
  line-height: 1.6;
}

ul {
  padding-left: 20px;
}
</style>